import { updateUser } from "../../redux/app-redux";

export default { updateUser };
